import { render, staticRenderFns } from "./CategoryPart.vue?vue&type=template&id=1bb9be57&scoped=true&"
import script from "./CategoryPart.vue?vue&type=script&lang=js&"
export * from "./CategoryPart.vue?vue&type=script&lang=js&"
import style0 from "./CategoryPart.vue?vue&type=style&index=0&id=1bb9be57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb9be57",
  null
  
)

export default component.exports